"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  label: 'Asia',
  prefix: 'flag',
  value: 'ASIA'
}, {
  label: 'Australia',
  prefix: 'flagaus',
  value: 'AU'
}, {
  label: 'Europe',
  prefix: 'flageuro',
  value: 'EU'
}, {
  label: 'United States',
  prefix: 'flagus',
  value: 'US'
}];
exports.default = _default;